import type { Feature } from 'geojson'

let rememberedDrawnFeature: Feature | null = null

function cloneFeature(feature: Feature): Feature {
  return JSON.parse(JSON.stringify(feature)) as Feature
}

export function rememberDrawnFeatureForBackNavigation(feature: Feature) {
  rememberedDrawnFeature = cloneFeature(feature)
}

export function getRememberedDrawnFeatureForBackNavigation() {
  return rememberedDrawnFeature ? cloneFeature(rememberedDrawnFeature) : null
}

export function clearRememberedDrawnFeatureForBackNavigation() {
  rememberedDrawnFeature = null
}
